// src/modules/app-views/_apps/appmulti/receivables/pages/Init/actions/actionButton.js
import { PlusOutlined } from '@ant-design/icons';

const receivablesInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_charge',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,
    onClick: ({ navigate, setPage }) => {
      setPage({ navigate, pageName: 'document', params: { _id: 'add' } });
    },
    dropdownItems: [],
  };
};

export default receivablesInitActionButton;
